<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="会员明细"
      id-key="RecordId"
      :data="data"
      :save-func="()=>{}"
      form-label-width="85px"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
    >
      <template slot="form">
       基本信息
        <el-row class="row-border">
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="企业名称">
                <span>创客咖啡</span>
              </el-form-item>
            </el-col>
             </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="联系人">
                <span>李四</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="联系电话">
                <span>13308770201</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="会员等级">
                <span>黄金会员</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="会员标签">
                <span>复购率高</span>
              </el-form-item>
            </el-col>
             </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="会员积分">
                <span>20000</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="会员余额">
                <span>30000</span>
              </el-form-item>
            </el-col>
          </el-row>
                 
         
        </el-row>

        订单记录
        <el-row>
           <el-col :span="24">
           <el-table border :data="Orders"  style="margin-top: 10px; margin-bottom:10px">
                <el-table-column prop="OrderNo" label="订单号" />
                <el-table-column prop="AmountMoney" label="应收金额" />
                <el-table-column prop="DiscountMoney" label="优惠金额" />
                <el-table-column prop="ReceiptsMoney" label="实收金额" />
                <el-table-column prop="ShippingFee" label="运费" />
                <el-table-column prop="SumMoney" label="合计金额" />
                               
                <el-table-column prop="OrderTime" label="订单时间" />
              
              </el-table>
          
          </el-col>
        </el-row>

        商品信息
        <el-row>
           <el-col :span="24">
           <el-table border :data="OrderGoods"  style="margin-top: 10px; margin-bottom:10px">
                <el-table-column prop="GoodsName" label="商品名称" />
                <el-table-column prop="AttributeValue" label="规格属性" />
               
                <el-table-column prop="MainUnitName" label="单位" />
                <el-table-column prop="DistributionPrice" label="单价" />
                <el-table-column prop="ActivityPrice" label="优惠后单价" >
                
                </el-table-column>    
                <el-table-column prop="MainunitCount" label="数量" />
                <el-table-column prop="SumAmount" label="金额" />
              </el-table>
          
          </el-col>
        </el-row>

        访问记录
        <el-row>
         
          <el-col :span="24">
            <el-table border :data="VisitList" style="margin-top: 10px; margin-bottom:10px">
              <el-table-column prop="VisitTime" label="访问时间"></el-table-column>
              <el-table-column prop="GoodsName" label="商品名称"></el-table-column>
              <el-table-column prop="AttributeValue" label="规格属性"></el-table-column>
            
            </el-table>
          </el-col>
        </el-row>


        
      </template>
      <template slot="footer">
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [detailsDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        
      },
       Orders: [{OrderNo:"O2024101900000005",AmountMoney:"120.00",DiscountMoney:"0.00",ReceiptsMoney:"120.00",ShippingFee:"0.00",SumMoney:"120.00",OrderTime:"2024-10-19 11:12:23"},{OrderNo:"O2024091100000002",AmountMoney:"230.00",DiscountMoney:"10.00",ReceiptsMoney:"220.00",ShippingFee:"0.00",SumMoney:"220.00",OrderTime:"2024-09-11 11:12:23"}], //商品信息
      OrderGoods: [{GoodsName:"营养粉",AttributeValue:"500毫升",MainUnitName:"罐",DistributionPrice:"60.00",ActivityPrice:"60.00",MainunitCount:"2",SumAmount:"120.00"}], //商品信息
    
      VisitList: [{VisitTime:"2024-10-19 11:12:10",GoodsName:"营养粉",AttributeValue:"500毫升"},{VisitTime:"2024-10-19 11:11:20",GoodsName:"营养粉",AttributeValue:"1000毫升"},{VisitTime:"2024-10-17 18:10:21",GoodsName:"凤凰单从",AttributeValue:"蜜桃香半斤装"}], //发货信息
   
     
    };
  },
  methods: {
    onDetailsOpened(data) {

    

    },
    onClosed() {
     
    },
  },
};
</script>